/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFontSize = (props: Props) => (
  <Icon viewBox="0 0 24 23" {...props}>
    <g fill="none">
      <path
        d="M18 2v2h-2v2h2v2h2V6h2V4h-2V2zm4 8h-6v2h6zM2 19 7.727 5h2.161l5.727 14h-2.16l-1.228-3H5.388l-1.227 3zM8.808 7.641 6.206 14h5.203z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFontSize as FontSize };
